import {useState} from 'react';
import {Link} from 'react-router';

import Page from '@/components/Page';

import {Report, ReportSummary} from './_reportsData';

function SpeculatorReports() {
  const [data, setData] = useState<Report[]>(ReportSummary);
  const myfunction = (idx: string) => {
    const filteredData = ReportSummary.filter(
      report =>
        report.report_name.toLowerCase().includes(idx.toLowerCase()) ||
        report.description.toLowerCase().includes(idx.toLowerCase())
    );
    setData(filteredData);
  };

  const getReportStats = (reports: Report[]) => {
    const totalReports = reports.length;
    const positionReports = reports.filter(report => report.report_type === 'Position').length;
    const productPerformanceReports = reports.filter(report => report.report_type === 'Product Performance').length;
    const marketAnalysisReports = reports.filter(report => report.report_type === 'Market Analysis').length;

    return {totalReports, positionReports, productPerformanceReports, marketAnalysisReports};
  };

  const {totalReports, positionReports, productPerformanceReports, marketAnalysisReports} = getReportStats(data);

  return (
    <Page currentPage="Reports">
      <div className="grid grid-cols-12 gap-x-6">
        <div className="col-span-12 xl:col-span-3 xxl:col-span-3">
          <div className="box Users-main-card primary">
            <div className="box-body">
              <div className="flex items-start">
                <div className="me-4">
                  <span className="avatar bg-primary !text-white">
                    <i className="ri-file-list-line text-[1.125rem]"></i>
                  </span>
                </div>
                <div className="flex-grow">
                  <span className="mb-1 block font-semibold text-[#8c9097] dark:text-white/50">Total Reports</span>
                  <h5 className="mb-1 text-[1.25rem] font-semibold">{totalReports}</h5>
                  <p className="mb-0">
                    <span className="badge bg-primary/10 text-primary">This Month</span>
                  </p>
                </div>
                <div>
                  <span className="text-[0.875rem] font-semibold text-success">+1.03%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 xl:col-span-3 xxl:col-span-3">
          <div className="box Users-main-card secondary">
            <div className="box-body">
              <div className="flex items-start">
                <div className="me-4">
                  <span className="avatar bg-secondary !text-white">
                    <i className="ri-pie-chart-line text-[1.125rem]"></i>
                  </span>
                </div>
                <div className="flex-grow">
                  <span className="mb-1 block font-semibold text-[#8c9097] dark:text-white/50">Position Reports</span>
                  <h5 className="mb-1 text-[1.25rem] font-semibold">{positionReports}</h5>
                  <p className="mb-0">
                    <span className="badge bg-secondary/10 text-secondary">This Month</span>
                  </p>
                </div>
                <div>
                  <span className="text-[0.875rem] font-semibold text-success">+0.36%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 xl:col-span-3 xxl:col-span-3">
          <div className="box Users-main-card warning">
            <div className="box-body">
              <div className="flex items-start">
                <div className="me-4">
                  <span className="avatar bg-warning !text-white">
                    <i className="ri-bar-chart-box-line text-[1.125rem]"></i>
                  </span>
                </div>
                <div className="flex-grow">
                  <span className="mb-1 block font-semibold text-[#8c9097] dark:text-white/50">
                    Product Performance Reports
                  </span>
                  <h5 className="mb-1 text-[1.25rem] font-semibold">{productPerformanceReports}</h5>
                  <p className="mb-0">
                    <span className="badge bg-warning/10 text-warning">This Month</span>
                  </p>
                </div>
                <div>
                  <span className="text-[0.875rem] font-semibold text-danger">-1.28%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 xl:col-span-3 xxl:col-span-3">
          <div className="box Users-main-card danger">
            <div className="box-body">
              <div className="flex items-start">
                <div className="me-4">
                  <span className="avatar bg-danger !text-white">
                    <i className="ri-bar-chart-line text-[1.125rem]"></i>
                  </span>
                </div>
                <div className="flex-grow">
                  <span className="mb-1 block font-semibold text-[#8c9097] dark:text-white/50">
                    Market Analysis Reports
                  </span>
                  <h5 className="mb-1 text-[1.25rem] font-semibold">{marketAnalysisReports}</h5>
                  <p className="mb-0">
                    <span className="badge bg-danger/10 text-danger">This Month</span>
                  </p>
                </div>
                <div>
                  <span className="text-[0.875rem] font-semibold text-success">+4.25%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-x-6">
        <div className="col-span-12 xl:col-span-12 xxl:col-span-12">
          <div className="box">
            <div className="box-header flex-wrap justify-between">
              <div className="box-title">Report Management</div>
              <div className="flex flex-wrap gap-2">
                <div className="me-3">
                  <input
                    className="ti-form-control form-control-sm"
                    type="text"
                    placeholder="Search Here"
                    aria-label=".form-control-sm example"
                    onChange={ele => {
                      myfunction(ele.target.value);
                    }}
                  />
                </div>
                <div className="hs-dropdown ti-dropdown">
                  <Link
                    to="#"
                    className="ti-btn ti-btn-primary !m-0 !gap-0 !bg-primary !px-2 !py-1 !text-[0.75rem] !font-medium !text-white"
                    aria-expanded="false"
                  >
                    Sort By<i className="ri-arrow-down-s-line ms-1 inline-block align-middle"></i>
                  </Link>
                  <ul className="hs-dropdown-menu ti-dropdown-menu hidden" role="menu">
                    <li>
                      <Link
                        className="ti-dropdown-item block !px-[0.9375rem] !py-2 !text-[0.8125rem] !font-medium"
                        to="#"
                      >
                        Newest
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="ti-dropdown-item block !px-[0.9375rem] !py-2 !text-[0.8125rem] !font-medium"
                        to="#"
                      >
                        Oldest
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="box-body">
              <div className="table-responsive">
                <table className="table-hover table-bordered table min-w-full whitespace-nowrap">
                  <thead>
                    <tr>
                      <th scope="col" className="text-start">
                        Report Name
                      </th>
                      <th scope="col" className="text-start">
                        Description
                      </th>
                      <th scope="col" className="text-start">
                        Type
                      </th>
                      <th scope="col" className="text-start">
                        Generated Date
                      </th>
                      <th scope="col" className="text-start">
                        Generated By
                      </th>
                      <th scope="col" className="text-start">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map(report => (
                      <tr
                        className="border border-solid border-inherit hover:bg-gray-100 dark:border-defaultborder/10 dark:hover:bg-light"
                        key={report.report_id}
                      >
                        <td>{report.report_name}</td>
                        <td>{report.description}</td>
                        <td>{report.report_type}</td>
                        <td>{report.generated_date}</td>
                        <td>{report.generated_by}</td>
                        <td>
                          <div className="flex flex-row items-center !gap-2 text-[0.9375rem]">
                            <button
                              className="ti-btn ti-btn-icon ti-btn-wave !m-0 !h-[1.75rem] !w-[1.75rem] !gap-0 bg-info/10 text-[0.8rem] text-info hover:border-info hover:bg-info hover:text-white"
                              onClick={() => alert(`Viewing report: ${report.report_name}`)}
                            >
                              <i className="ri-eye-line"></i>
                            </button>
                            <button
                              className="ti-btn ti-btn-icon ti-btn-wave !m-0 !h-[1.75rem] !w-[1.75rem] !gap-0 bg-danger/10 text-[0.8rem] text-danger hover:border-danger hover:bg-danger hover:text-white"
                              onClick={() => alert(`Deleting report: ${report.report_name}`)}
                            >
                              <i className="ri-delete-bin-line"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="box-footer">
              <div className="items-center sm:flex">
                <div className="text-defaulttextcolor/70">
                  Showing {data.length} Entries <i className="bi bi-arrow-right ms-2 font-semibold"></i>
                </div>
                <div className="ms-auto">
                  <nav aria-label="Page navigation" className="pagination-style-4">
                    <ul className="ti-pagination mb-0">
                      <li className="page-item disabled">
                        <Link className="page-link" to="#">
                          Prev
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link active" to="#">
                          1
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link" to="#">
                          2
                        </Link>
                      </li>
                      <li className="page-item">
                        <Link className="page-link !text-primary" to="#">
                          next
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default SpeculatorReports;
